import { Create, required, SimpleForm, TextInput } from 'react-admin';

const TestimonialCategoriesCreate = () => {
    return (
        <Create title={'Create Testimonial Category'} redirect={'/testimonial-category'}>
            <SimpleForm>
                <TextInput source="name" fullWidth validate={[required()]} />
            </SimpleForm>
        </Create>
    );
};

export default TestimonialCategoriesCreate;
